<template>
    <div id="SetupCompletion" class="fade-in">
        <div class="image-container slide-down">
            <img src="../../../assets/setup.png" alt="setup" />
        </div>
        <div class="description slide-up">
            {{ $t("finalStepsText") }}
        </div>
        <div class="loading-indicator fade-in-delay">
            <div class="dots">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
        <div class="completion-text slide-up-delay">{{ $t("greetingText") }}</div>
        <div class="countdown-text">
            {{ $t("redirectingIn") }} {{ countdown }} {{ $t("seconds") }}
        </div>
    </div>
</template>

<script>
export default {
    name: "SetupCompletion",
    props: {
        startTime: Number,
    },
    data() {
        return {
            countdown: 0,
        };
    },
    methods: {
        startCountdown() {
            this.interval = setInterval(() => {
                this.countdown = Math.max(this.countdown - 1, 0);
                if (this.countdown <= 0) {
                    // window.location.href = `https://${this.siteName}`;
                }
            }, 1000);
        },
    },
    created() {
        this.countdown = Math.max(45 - Math.floor((Date.now() - this.startTime) / 1000), 0);
        this.startCountdown();
    },
    beforeDestroy() {
        clearInterval(this.interval);
        clearTimeout(this.redirectTimer);
    },
    mounted() {
        // Bu component sadece görsel gösterim yapacak
        // Yönlendirme artık Footer.vue tarafından yapılıyor
    },
    computed: {
        siteName() {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get("sitename") || "code1.local.supsis.live";
        },
        remainingTime() {
            const elapsed = Math.floor((Date.now() - this.startTime) / 1000);
            return Math.max(45 - elapsed, 0);
        },
        elapsedSeconds() {
            return Math.floor((Date.now() - this.startTime) / 1000);
        }
    }
};
</script>
<style lang="scss" scoped>
#SetupCompletion {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    background-image: url("../../../assets/BackgroundOne.png");
    background-repeat: no-repeat;
    background-size: cover;
    overflow: hidden;
    text-align: center;
    color: #272657;

    .image-container {
        margin-bottom: 20px;

        img {
            max-width: 600px;
            width: 100%;
            height: auto;
            display: block;
            margin: 0 auto;
        }
    }

    .description {
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-size: 1.2rem;
        font-weight: 500;
        color: #5d5b8d;
        margin-bottom: 30px;
        max-width: 800px;
        line-height: 1.6;
    }

    .loading-indicator {
        display: flex;
        justify-content: center;
        margin-bottom: 20px;

        .dots {
            display: flex;
            gap: 5px;

            span {
                width: 12px;
                height: 12px;
                background-color: #FD6144;
                border-radius: 50%;
                animation: bounce 1.5s infinite, fadeInDot 0.5s forwards;
                opacity: 0;

                &:nth-child(1) { animation-delay: 0.8s, 0.8s; }
                &:nth-child(2) { animation-delay: 1.0s, 1.0s; }
                &:nth-child(3) { animation-delay: 1.2s, 1.2s; }
                &:nth-child(4) { animation-delay: 1.4s, 1.4s; }
            }
        }
    }

    .completion-text {
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-size: 1.4rem;
        font-weight: 600;
        color: #272657;
    }

    &.fade-in {
        animation: fadeIn 0.8s ease-in;
    }

    .slide-down {
        animation: slideDown 1s ease-out;
    }

    .slide-up {
        animation: slideUp 1s ease-out;
    }

    .fade-in-delay {
        animation: fadeIn 1s ease-in 0.5s both;
    }

    .slide-up-delay {
        animation: slideUp 1s ease-out 0.7s both;
    }

    .countdown-text {
        display: none;
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-size: 1.1rem;
        color: #5d5b8d;
        margin-top: 20px;
        animation: fadeIn 1s ease-in 1s both;
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes slideDown {
    from {
        transform: translateY(-50px);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes slideUp {
    from {
        transform: translateY(50px);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes fadeInDot {
    to {
        opacity: 1;
    }
}

@keyframes bounce {
    0%, 80%, 100% {
        transform: scale(0.3);
    }
    40% {
        transform: scale(1);
    }
}
</style>